<template>
  <div class="pt_price">
    <div class="bg">
      <div class="image">
        <img :src="goodsImg" alt>
      </div>
      <p class="goodsname">{{goodsName}}</p>
      <div class="content_price">
        <p class="diamond">
          <input class="input" type="number" min="1" v-model="price" :placeholder="prices" @focus="hidePrices">
        </p>
        <div class="caikuang">
          <p class="input">{{caikuang}}</p>
        </div>
      </div>
      <div class="btn">
        <img src="../../../assets/images/active/login.png" alt class="btn_image">
        <p class="font">上架</p>
        <div class="mocen" @click="putaway"></div>
      </div>
      <!-- 商品上架确认弹窗 -->
       <div class="motail" v-show="isMotail">
          <div class="motailin" >
          <p class="title">已设置商品价格</p>
          <p class="item"> 
            <span class="queren" @click="setprice">确认</span>
            <span class="close" @click="close">取消</span>
            </p>
         </div>
        </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      goodsId: "",
      goodsName: "",
      goodsImg: "",
      price: "",
      prices: "请输入商品价格",
      isMotail: false,
    };
  },
  computed: {
    caikuang() {
      console.log(this.price);
      if (this.price === "") {
        return "根据输入的钻石/2生成";
      }
      if (this.price < 1) {
        this.price = 1;
      }
      return Math.floor(this.price / 2);
    }
  },
  created() {
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
    this.caikuang = this.price / 2;
    this.goodsId = this.$route.query.goodsid;
    this.goodsName = this.$route.query.name;
    this.goodsImg = this.$route.query.img;
  },
  methods: {
    putaway() {
        if(!this.price){
            return
        }else if(this.price){
          this.isMotail=true
        }
    },
    close(){
      this.isMotail=false
    },
    setprice(){
      this.agree()
    },
    hidePrices() {
      this.price = "";
    },
    close(){
      this.isMotail=false
    },
    agree(){
       axios
        .post(this.$interfaces.saveUserActivityLoveShopGoods, {
          userGuid: this.$store.state.userguid,
          token: this.$store.state.token,
          goodsId: this.goodsId,
          goodsName: this.goodsName,
          price: this.price
        })
        .then(res => {
          if(res.data.code == 400){
            this.$router.push({ path: "/login" });
            return
          }
          this.$router.push("/goods");
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.pt_price {
  width: 100%;
  height: 100%;
}
.pt_price .bg {
  background: url("../../../assets/images/active/bg/setprice.png") no-repeat
    left top;
  background-size: cover;
  height: 33.35rem;
  position: relative;
  display: flex;
  justify-content: center;
  text-align: center;
}
.pt_price .bg .motail{
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 33.35rem;
  background:rgba(0,0,0,.5);
  display: flex;
  justify-content: center;
  
}
.pt_price .bg .motail .motailin  .item{
  font-size:0.6rem;
  margin-top:0.5rem;
  color:red;
}
.pt_price .bg .motail .motailin .title{
  font-size:0.5rem;
}
.pt_price .bg .motail .motailin  .item .queren{
  margin-right:0.5rem;
}
.pt_price .bg .motail .motailin{
  padding-top:0.5rem;
  position: absolute;
  top:45%;
  width: 6rem;
  height: 2.75rem;
  background:white;
  border-radius: 0.5rem;
}

.pt_price .bg .image {
  position: absolute;
  top: 3.925rem;
  width: 5rem;
  height: 5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 2.5rem;
  overflow: hidden;
}
.pt_price .bg .image img {
  width: 100%;
  height: 100%;
}
.pt_price .bg .goodsname {
  position: absolute;
  top: 9.675rem;
  font-size: 0.7rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(117, 86, 98, 1);
}
.pt_price .bg .content_price {
  position: absolute;
  top: 14.7rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  
}
.pt_price .bg .content_price .diamond {
  margin-top: 0.25rem;
  width: 9.5rem;
  height: 2.5rem;
  line-height: 1rem;
  margin-bottom: 2.225rem;
  overflow: hidden;
}
.pt_price .bg .content_price .diamond .input{
 caret-color:rgba(0,0,0,.2);
 padding-top:0.25rem;
 width: 9.5rem;
  height: 2.5rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.85rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(251, 187, 205, 1);
  border: none;
  /* height: 2.5rem;
  line-height: 2.5rem; */
}
.pt_price .bg .content_price .caikuang {
  
  width: 9.5rem;
  height: 2rem;
  line-height: 2rem;
  overflow: hidden;
}
.pt_price .bg .content_price .caikuang .input {
  text-align: center;
  font-size: 0.85rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(251, 187, 205, 1);
  border: none;
  height: 2.5rem;
  line-height: 2.5rem;
}
/* input {
  text-align: center;
  font-size: 0.85rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(251, 187, 205, 1);
  border: none;
  height: 2.5rem;
  line-height: 2.5rem;
} */
.pt_price .bg .btn {
  position: absolute;
  bottom: 6.675rem;
  width: 16rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: white;
  font-size: 1rem;
}
.pt_price .bg .btn .mocen {
  position: absolute;
  left: 0;
  top: 0;
  width: 16rem;
  height: 3rem;
  color: white;
}
.pt_price .bg .btn .font {
  position: absolute;
  top: 0;
  left: 0;
  width: 16rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: white;
  font-size: 1rem;
}
.pt_price .bg .btn img {
  width: 100%;
  height: 100%;
}
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: pink;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: pink;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: pink;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: pink;
}
</style>






// WEBPACK FOOTER //
// src/components/active/view/setprice.vue